module.exports = __webpack_public_path__ + "static/media/iconLock.5e1d8ba4.svg";